import Vue from 'vue';
import Router from 'vue-router';
import Auth from '@/js/api/auth';

import Login from '@/js/views/auth/Login';
import Logout from '@/js/views/auth/Logout';
import MainTemplate from '@/js/views/templates/Main';

import ShopTemplate from '@/js/views/templates/Shop';
import ProductCategory from '@/js/views/shop/ProductCategory';
import Product from '@/js/views/shop/Product';
import Cart from '@/js/views/shop/Cart';
import Checkout from '@/js/views/shop/Checkout';
import MyOrders from '@/js/views/shop/MyOrders';
import ViewOrder from '@/js/views/shop/ViewOrder';
import OrderComplete from '@/js/views/shop/OrderComplete';

import SettingsTemplate from '@/js/views/templates/Settings';
import MyProfile from '@/js/views/settings/MyProfile';

Vue.use(Router);

const beforeEach = (to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (!Auth.isAuthenticated()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
};

const routes = [
  {
    path: '/',
    redirect: '/app',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
  },
  {
    path: '/app',
    component: MainTemplate,
    redirect: '/app/shop',
    meta: { auth: true },
    children: [
      {
        path: 'shop',
        name: 'shop',
        component: ShopTemplate,
        redirect: '/app/shop/category/all',
        children: [
          {
            path: 'category/:categoryId',
            name: 'category',
            component: ProductCategory,
          },
          {
            path: 'product/:productId',
            name: 'view-product',
            component: Product,
          },
          {
            path: 'cart',
            name: 'cart',
            component: Cart,
          },
          {
            path: 'checkout',
            name: 'checkout',
            component: Checkout,
          },
          {
            path: 'my-orders',
            name: 'my-orders',
            component: MyOrders,
          },
          {
            path: 'order-complete/:orderId',
            name: 'order-complete',
            component: OrderComplete,
          },
          {
            path: 'my-orders/:orderId',
            name: 'view-order',
            component: ViewOrder,
          },
        ],
      },
      {
        path: 'settings',
        name: 'settings',
        component: SettingsTemplate,
        redirect: '/app/settings/my-profile',
        children: [
          {
            path: 'my-profile',
            name: 'my-profile',
            component: MyProfile,
          },
        ],
      },
    ],
  },
];

const RouterInstance = new Router({
  mode: 'history',
  routes,
});

RouterInstance.beforeEach(beforeEach);

export default RouterInstance;



// WEBPACK FOOTER //
// ./src/js/router.js